const wrapper = document.querySelector(".bike-price-wrapper");

if (!wrapper) {
  console.error(".bike-price-wrapper NOT FOUND");
} else {
  initLocationPricing();
}

// MAIN INIT
async function initLocationPricing() {
  let priceEl =
    wrapper.querySelector(".test-sale-price") ||
    wrapper.querySelector(".dynamic-price");

  const stateDropdown = document.querySelector(".state-selector");

  // INITIAL LOADING UI
  wrapper.classList.add("loading");

  if (priceEl) {
    priceEl.dataset.originalPrice = priceEl.textContent;
    priceEl.textContent = "Loading...";
  }

  // GET INITIAL VARIANT
  let currentVariantId = document.querySelector(`input[name="id"]`)?.value;

  // CITY ALIASES
  const cityAliases = {
    Bengaluru: "Bangalore",
    "Bangalore Urban": "Bangalore",
    Bombay: "Mumbai",
    Madras: "Chennai",
    Trivandrum: "Thiruvananthapuram",
  };

  // MEMORY CACHE
  let cachedLocation = null;

  let isInitialLoad = true;

  // DEFAULT FALLBACK
  const defaultPrice =
    wrapper.dataset.defaultPrice?.trim() ||
    priceEl?.textContent?.trim() ||
    "₹1.94 Lakh";

  // LOCAL STORAGE CACHE
  const STORAGE_KEY = "jawa_user_location";

  // GET USER LOCATION
  async function getUserLocation() {
    // MEMORY CACHE
    if (cachedLocation) {
      return cachedLocation;
    }

    // LOCAL STORAGE CACHE
    const storedLocation = localStorage.getItem(STORAGE_KEY);

    if (storedLocation) {
      try {
        cachedLocation = JSON.parse(storedLocation);

        return cachedLocation;
      } catch (e) {}
    }

    // GEOLOCATION
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve(null);

        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const lat = position.coords.latitude;

            const lon = position.coords.longitude;

            const apiUrl = `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`;

            const response = await fetch(apiUrl);

            const data = await response.json();

            let city =
              data.city ||
              data.locality ||
              data.localityInfo?.administrative?.[2]?.name ||
              "";

            let state = data.principalSubdivision || "";

            city = cityAliases[city] || city;

            cachedLocation = {
              city,
              state,
            };

            // SAVE CACHE
            localStorage.setItem(STORAGE_KEY, JSON.stringify(cachedLocation));

            resolve(cachedLocation);
          } catch (error) {
            resolve(null);
          }
        },

        () => {
          resolve(null);
        },

        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
    });
  }

  // REMOVE LOADING
  function removeLoadingState() {
    wrapper.classList.remove("loading");
  }

  function populateStatesDropdown(variantData, selectedState = "Delhi") {
    if (!stateDropdown) return;

    stateDropdown.innerHTML = "";

    if (!Object.keys(variantData.states || {}).length) {
      stateDropdown.innerHTML = '<option value="">No states available</option>';
      return;
    }

    const states = Object.keys(variantData.states || {});

    states.sort();

    states.forEach((state) => {
      const option = document.createElement("option");

      option.value = state;

      option.textContent = state;

      if (state === selectedState) {
        option.selected = true;
      }

      stateDropdown.appendChild(option);
    });
  }

  // UPDATE PRICE
  async function updateLocationPrice(variantId) {
    priceEl =
      wrapper.querySelector(".test-sale-price") ||
      wrapper.querySelector(".dynamic-price");

    console.log("Variant ID:", variantId);
    console.log(window.variantLocationPrices[variantId]);
    const variantData = window.variantLocationPrices?.[variantId];

    // NO JSON FOUND
    if (!variantData || typeof variantData !== "object") {
      if (priceEl) {
        priceEl.textContent = defaultPrice;
      }

      removeLoadingState();

      return;
    }

    // FALLBACK VALUES
    let finalPrice = variantData.default?.price || defaultPrice;

    let selectedState = variantData.default?.location || "Delhi";

    // GET LOCATION
    const location = await getUserLocation();

    // LOCATION MATCH
    if (location) {
      const stateData = variantData.states?.[location.state];

      // CITY LEVEL PRICE
      const cityData = stateData?.[location.city];

      if (cityData?.price) {
        finalPrice = cityData.price;

        selectedState = location.state;
      }

      // STATE LEVEL PRICE
      else if (stateData?.price) {
        finalPrice = stateData.price;

        selectedState = location.state;
      }
    }

    const availableStates = Object.keys(variantData.states || {});

    if (!availableStates.includes(selectedState)) {
      selectedState = availableStates.includes("Delhi")
        ? "Delhi"
        : availableStates[0];
    }

    populateStatesDropdown(variantData, selectedState);

    // UPDATE UI
    if (priceEl) {
      priceEl.textContent = finalPrice;
    }

    // REMOVE LOADING
    removeLoadingState();
    isInitialLoad = false;
  }

  // INITIAL LOAD
  currentVariantId = document.querySelector('input[name="id"]')?.value;

  if (currentVariantId) {
    updateLocationPrice(currentVariantId);
  }

  document.addEventListener("variant:change", ({ detail }) => {
    if (!detail?.variant?.id) return;

    currentVariantId = String(detail.variant.id);

    // Re-query in case Shopify has re-rendered the price element
    priceEl =
      wrapper.querySelector(".test-sale-price") ||
      wrapper.querySelector(".dynamic-price");

    updateLocationPrice(currentVariantId);
  });

  // STATE DROPDOWN CHANGE
  stateDropdown?.addEventListener("change", () => {
    const variantData = window.variantLocationPrices?.[currentVariantId];

    if (!variantData) return;

    const selectedState = stateDropdown.value;

    const stateData = variantData.states?.[selectedState];

    if (!stateData) return;

    const price = stateData.price ?? variantData.default?.price ?? defaultPrice;

    if (priceEl) {
      priceEl.textContent = price;
    }
  });
}
